import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/gallery.svg';

export const IconGallery = createIconComponent(Icon);
